'use strict';

const initActionPlanNav = () => {
    const nav = document.querySelector('.action-plan__nav');
    if (!nav) return;

    const navLinks = nav.querySelectorAll('.action-plan__nav-link');
    const themes = Array.from(document.querySelectorAll('.action-plan__theme'));
    if (!themes.length) return;

    // The nav is hidden by default and only revealed once the user scrolls
    // past the top of the action plan section.
    const section = nav.closest('.action-plan') || nav.parentElement;
    const adminBarOffset = document.body.classList.contains('admin-bar')
        ? (window.matchMedia('(min-width: 783px)').matches ? 32 : 46)
        : 0;

    let stuckTicking = false;
    const updateStuck = () => {
        stuckTicking = false;
        const stuck = section.getBoundingClientRect().top <= adminBarOffset;
        nav.classList.toggle('action-plan__nav--stuck', stuck);
    };

    const onScroll = () => {
        if (stuckTicking) return;
        stuckTicking = true;
        window.requestAnimationFrame(updateStuck);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateStuck();

    const visibleSections = new Set();

    const setActive = () => {
        const activeTheme = themes.find(theme => visibleSections.has(theme));
        navLinks.forEach(link => {
            link.classList.toggle(
                'action-plan__nav-link--active',
                !!activeTheme && link.getAttribute('href') === `#${activeTheme.id}`
            );
        });
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                visibleSections.add(entry.target);
            } else {
                visibleSections.delete(entry.target);
            }
        });
        setActive();
    }, {
        rootMargin: '-10% 0px -60% 0px',
    });

    themes.forEach(theme => observer.observe(theme));
};

export default initActionPlanNav;
